module.exports = __webpack_public_path__ + "img/ic_in.d3ce4e31.svg";